module.exports = __webpack_public_path__ + "img/郾城区-c.888845b2.png";